import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "login-container" }
const _hoisted_2 = { class: "login-card" }
const _hoisted_3 = { class: "login-header" }
const _hoisted_4 = {
  key: 0,
  class: "test-server-notice"
}
const _hoisted_5 = { class: "input-group" }
const _hoisted_6 = { class: "input-group" }
const _hoisted_7 = { class: "checkbox-group" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = { class: "biz-gubun-list" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "biz-gubun-info" }
const _hoisted_12 = { class: "member-name" }
const _hoisted_13 = { class: "member-biz" }

import { ref, onMounted, computed, watch } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'LoginPage',
  setup(__props) {

const store = useStore();
const router = useRouter();

const domainPrefix = window.location.hostname.includes('test.caion') ? 'test_' : '';
const AUTO_LOGIN_PREF_KEY = `${domainPrefix}caion_auto_login_pref`;

// 테스트 서버 여부
const isTestServer = computed(() => window.location.hostname.includes('test.caion'));

// 폼 ref
const formRef = ref<any>(null);

// 입력값
const loginId = ref('');
const loginPw = ref('');
const showPassword = ref(false);
const saveId = ref(false);
const autoLogin = ref(false);

// 사업구분 선택 다이얼로그
const bizGubunDialog = ref(false);
const bizGubunMembers = ref<any[]>([]);
const selectedMemberIdx = ref<number | null>(null);

// 로딩 상태
const loading = computed(() => store.getters.isLoading);

// 유효성 검사 규칙
const rules = {
  required: (v: string) => !!v || '필수 입력 항목입니다.'
};

watch(autoLogin, (on) => {
  localStorage.setItem(AUTO_LOGIN_PREF_KEY, on ? '1' : '0');
  if (on) saveId.value = true;
});

watch(saveId, (on) => {
  if (!on && autoLogin.value) autoLogin.value = false;
});

const goHome = (userType: string) => {
  if (userType === 'member') {
    router.push('/m/info');
  } else {
    router.push('/member');
  }
};

// 로그인 처리
const handleLogin = async (memberCode?: number) => {
  const { valid } = await formRef.value.validate();
  
  if (!valid) return;

  const result = await store.dispatch('login', {
    loginId: loginId.value,
    loginPw: loginPw.value,
    saveId: saveId.value,
    autoLogin: autoLogin.value,
    memberCode
  });

  if (result?.requireBizGubunSelect) {
    bizGubunMembers.value = result.members || [];
    selectedMemberIdx.value = null;
    bizGubunDialog.value = true;
    return;
  }

  if (result?.success && result.user) {
    goHome(result.user.userType);
  }
};

// 사업구분 선택 취소
const cancelBizGubunSelect = () => {
  bizGubunDialog.value = false;
  bizGubunMembers.value = [];
  selectedMemberIdx.value = null;
};

// 사업구분 선택 완료
const confirmBizGubunSelect = async () => {
  if (!selectedMemberIdx.value) return;
  
  bizGubunDialog.value = false;
  await handleLogin(selectedMemberIdx.value);
};

// 초기화
onMounted(() => {
  const savedLoginId = store.getters.savedId;
  if (savedLoginId) {
    loginId.value = savedLoginId;
    saveId.value = true;
  }

  if (localStorage.getItem(AUTO_LOGIN_PREF_KEY) === '1') {
    autoLogin.value = true;
    saveId.value = true;
  }
  
  if (store.getters.isLoggedIn) {
    goHome(store.getters.userType);
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[9] || (_cache[9] = _createElementVNode("h1", { class: "login-title" }, "CAION", -1)),
        _cache[10] || (_cache[10] = _createElementVNode("p", { class: "login-subtitle" }, "통합 관리 시스템", -1)),
        (isTestServer.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_v_icon, {
                size: "18",
                class: "mr-1"
              }, {
                default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                  _createTextVNode("mdi-alert-circle", -1)
                ]))]),
                _: 1
              }),
              _cache[8] || (_cache[8] = _createElementVNode("span", null, "테스트 서버: 관리자 계정만 로그인 가능", -1))
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_v_form, {
        ref_key: "formRef",
        ref: formRef,
        onSubmit: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (handleLogin()), ["prevent"])),
        class: "login-form"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_v_text_field, {
              modelValue: loginId.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((loginId).value = $event)),
              label: "아이디",
              "prepend-inner-icon": "mdi-account",
              variant: "outlined",
              density: "comfortable",
              rules: [rules.required],
              disabled: loading.value,
              onKeyup: _withKeys(handleLogin, ["enter"])
            }, null, 8, ["modelValue", "rules", "disabled"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_v_text_field, {
              modelValue: loginPw.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((loginPw).value = $event)),
              label: "비밀번호",
              "prepend-inner-icon": "mdi-lock",
              type: showPassword.value ? 'text' : 'password',
              "append-inner-icon": showPassword.value ? 'mdi-eye' : 'mdi-eye-off',
              variant: "outlined",
              density: "comfortable",
              rules: [rules.required],
              disabled: loading.value,
              "onClick:appendInner": _cache[2] || (_cache[2] = ($event: any) => (showPassword.value = !showPassword.value)),
              onKeyup: _withKeys(handleLogin, ["enter"])
            }, null, 8, ["modelValue", "type", "append-inner-icon", "rules", "disabled"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_v_checkbox, {
              modelValue: saveId.value,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((saveId).value = $event)),
              label: "아이디 저장",
              density: "compact",
              "hide-details": "",
              color: "primary"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_v_checkbox, {
              modelValue: autoLogin.value,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((autoLogin).value = $event)),
              label: "자동 로그인",
              density: "compact",
              "hide-details": "",
              color: "primary"
            }, null, 8, ["modelValue"])
          ]),
          _cache[13] || (_cache[13] = _createElementVNode("p", { class: "auto-login-hint" }, "자동 로그인을 켜면 브라우저를 닫아도 최대 30일간 로그인 상태가 유지됩니다. (보안상 하루에 한 번 정도 조용히 갱신됩니다)", -1)),
          _createVNode(_component_v_btn, {
            type: "submit",
            size: "large",
            block: "",
            loading: loading.value,
            disabled: loading.value,
            variant: "flat",
            class: "login-btn btn-search"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, { left: "" }, {
                default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                  _createTextVNode("mdi-login", -1)
                ]))]),
                _: 1
              }),
              _cache[12] || (_cache[12] = _createTextVNode(" 로그인 ", -1))
            ]),
            _: 1
          }, 8, ["loading", "disabled"])
        ]),
        _: 1
      }, 512),
      _cache[14] || (_cache[14] = _createElementVNode("div", { class: "login-footer" }, null, -1))
    ]),
    _cache[22] || (_cache[22] = _createElementVNode("div", { class: "bg-decoration" }, [
      _createElementVNode("div", { class: "circle circle-1" }),
      _createElementVNode("div", { class: "circle circle-2" }),
      _createElementVNode("div", { class: "circle circle-3" })
    ], -1)),
    _createVNode(_component_v_dialog, {
      modelValue: bizGubunDialog.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((bizGubunDialog).value = $event)),
      "max-width": "420",
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "biz-gubun-dialog" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "dialog-header" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, { class: "mr-2" }, {
                  default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                    _createTextVNode("mdi-office-building-marker", -1)
                  ]))]),
                  _: 1
                }),
                _cache[17] || (_cache[17] = _createTextVNode(" 사업구분 선택 ", -1)),
                _createElementVNode("button", {
                  type: "button",
                  class: "biz-gubun-dialog__close",
                  disabled: loading.value,
                  "aria-label": "닫기",
                  onClick: cancelBizGubunSelect
                }, [
                  _createVNode(_component_v_icon, { size: "18" }, {
                    default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                      _createTextVNode("mdi-close", -1)
                    ]))]),
                    _: 1
                  })
                ], 8, _hoisted_8)
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, { class: "dialog-body" }, {
              default: _withCtx(() => [
                _cache[19] || (_cache[19] = _createElementVNode("p", { class: "dialog-desc" }, [
                  _createTextVNode("동일한 아이디로 등록된 여러 기관이 있습니다."),
                  _createElementVNode("br"),
                  _createTextVNode("접속할 기관을 선택해주세요.")
                ], -1)),
                _createElementVNode("div", _hoisted_9, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bizGubunMembers.value, (member) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: member.idx,
                      class: _normalizeClass(["biz-gubun-item", { selected: selectedMemberIdx.value === member.idx }]),
                      onClick: ($event: any) => (selectedMemberIdx.value = member.idx)
                    }, [
                      _createElementVNode("div", {
                        class: "biz-gubun-color",
                        style: _normalizeStyle({ backgroundColor: member.bizGubunColor })
                      }, null, 4),
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("span", _hoisted_12, _toDisplayString(member.name), 1),
                        _createElementVNode("span", _hoisted_13, _toDisplayString(member.bizGubunName || member.bizGubun), 1)
                      ]),
                      (selectedMemberIdx.value === member.idx)
                        ? (_openBlock(), _createBlock(_component_v_icon, {
                            key: 0,
                            color: "primary",
                            class: "check-icon"
                          }, {
                            default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                              _createTextVNode("mdi-check-circle", -1)
                            ]))]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ], 10, _hoisted_10))
                  }), 128))
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, { class: "dialog-actions" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  variant: "text",
                  class: "btn-cancel",
                  onClick: cancelBizGubunSelect
                }, {
                  default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                    _createTextVNode("취소", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  variant: "flat",
                  class: "btn-confirm",
                  disabled: !selectedMemberIdx.value,
                  loading: loading.value,
                  onClick: confirmBizGubunSelect
                }, {
                  default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                    _createTextVNode(" 선택 완료 ", -1)
                  ]))]),
                  _: 1
                }, 8, ["disabled", "loading"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})